// Static data loading + the qualifying-years helper (client-side equivalent of
// data.enso.count_oni_years_in_range).

import type { Storm } from "../engine/types";

export type OniYears = Record<string, number>;

export async function loadTrackDb(): Promise<Storm[]> {
  const res = await fetch("/data/track_database.json");
  if (!res.ok) throw new Error(`track DB load failed: ${res.status}`);
  return res.json();
}

export async function loadOniYears(): Promise<OniYears> {
  const res = await fetch("/data/oni_years.json");
  if (!res.ok) throw new Error(`oni_years load failed: ${res.status}`);
  return res.json();
}

/** Count years whose hurricane-season mean ONI falls in [min,max] within [yMin,yMax]. */
export function countQualifyingYears(
  oniYears: OniYears,
  oniRange: [number, number],
  yearMin: number,
  yearMax: number,
): number {
  let n = 0;
  for (const [yStr, mean] of Object.entries(oniYears)) {
    const y = Number(yStr);
    if (y < yearMin || y > yearMax) continue;
    if (oniRange[0] <= mean && mean <= oniRange[1]) n++;
  }
  return n;
}
